export enum ProviderDoNotSendReason {
  specialty = 'specialty',
  employed = 'employed',
}